import { JsonObject, JsonProperty } from "ta-json";

import Guard from "../../guard";

export interface IMemberCondition {
    memberName: string;
}

@JsonObject()
export class MemberCondition implements IMemberCondition {
    @JsonProperty("member")
    readonly memberName: string;

    constructor(memberName: string) {
        this.memberName = memberName;
    }
}

// // /**
// //  * Condition triggered on the value of the property member or ancestor id of the relation.
// //  */
// // export class MemberValueCondition extends MemberCondition {
// //     /**
// //      * Non {@link null} case insensitive and culture agnostic value which is compared against
// //      * entity property value or relation member taxonomy ancestors. Possible types of this
// //      * value are {@link string} or {@link number}.
// //      * Note that an empty string is treated as unspecified value not triggering the condition.
// //      */
// //     @JsonProperty("value")
// //     value: number|string;
// //
// //     constructor(memberName: string, value: number|string) {
// //         super(memberName);
// //         Guard.notNullOrUndefined(value);
// //
// //         this.value = value;
// //     }
// // }

/**
 * Condition triggered if the relation does not have ancestor of given definition id.
 */
@JsonObject()
export class NoAncestorMemberCondition extends MemberCondition {
    /**
     * Gets or sets id of the linked {@link IEntityDefinition}.
     */
    @JsonProperty("definitionId")
    definitionId: number;

    constructor(memberName: string, definitionId: number) {
        super(memberName);
        this.definitionId = definitionId;
    }
}

/**
 * Condition triggered on the value of the property.
 */
@JsonObject()
export class StringMemberCondition extends MemberCondition {
    /**
     * Non null case insensitive and culture agnostic value which is compared against entity property value.
     * Note that the value equal to an empty string is treated as unspecified value not triggering the condition.
     */
    @JsonProperty("value")
    value: string;

    constructor(memberName: string, value: string) {
        super(memberName);
        Guard.notNullOrUndefined(value);

        this.value = value;
    }
}

/**
 * Condition triggered on the value of the property.
 */
@JsonObject()
export class BooleanMemberCondition extends MemberCondition {
    /**
     * Boolean value for the condition.
     */
    @JsonProperty("value")
    value: boolean;

    constructor(memberName: string, value: boolean) {
        super(memberName);
        Guard.notNullOrUndefined(value);

        this.value = value;
    }
}

/**
 * Condition triggered on ancestor id of the relation.
 */
@JsonObject()
export class RelationMemberCondition extends MemberCondition {
    /**
     * Id of the entity.
     */
    @JsonProperty("entityId")
    entityId: number;

    constructor(memberName: string, entityId: number) {
        super(memberName);
        this.entityId = entityId;
    }
}
